/**
 * dealTier — Tony's 2026-05-09 calibration #4 deal-quality bands.
 *
 * Mirrors `backend/product/src/modules/deals/deals.service.ts::dealTier()`.
 * If you tune the bands on the backend, sync these constants. Currently
 * replicated rather than fetched from a /config endpoint — see
 * "Wider-impact validation" section in the calibration plan.
 *
 * Usage:
 *   const tier = dealTierFromDiscount(deal.discountPct);
 *   if (tier) renderEmoji(DEAL_TIER_EMOJI[tier]);
 */

export type DealTier = 'exceptional' | 'strong' | 'standard';

export const DEAL_TIER_EMOJI: Record<DealTier, string> = {
  exceptional: '🔥',
  strong:      '✓',
  standard:    '•',
};

export const DEAL_TIER_LABEL: Record<DealTier, string> = {
  exceptional: 'Exceptional',
  strong:      'Strong',
  standard:    'Standard',
};

/** Bands match `deals.service.ts::dealTier()` (≥40 / 25-39 / <25). Returns
 *  null when discountPct is missing — callers render a neutral "—" cell. */
export function dealTierFromDiscount(pct: number | null | undefined): DealTier | null {
  if (pct === null || pct === undefined || !Number.isFinite(pct)) return null;
  if (pct >= 40) return 'exceptional';
  if (pct >= 25) return 'strong';
  return 'standard';
}
